import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Rates page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useRatesTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.rates.intro.title'),
                        description: t('tour.rates.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.rates.addButton.title'),
                        description: t('tour.rates.addButton.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:first-child a',
                    popover: {
                        title: t('tour.rates.rateName.title'),
                        description: t('tour.rates.rateName.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.rates.nameFilter.title'),
                        description: t('tour.rates.nameFilter.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
